export default __webpack_public_path__ + "static/media/Group1030.410c5dc0.svg";